import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EXPIRY_TIME, REPO_TOKEN, USER_TOKEN } from '@string';
import { CookieService } from '../services/cookie.service';
import { PackageService } from '../services/package.service';
import { UserService } from '../services/user.service';
import { environment } from '@env/environment';
import { OnspotConsultationService } from '../services/onspot-consultation.service';
import * as moment from 'moment';
@Component({
  selector: 'app-package-link',
  templateUrl: './package-link.component.html',
  styleUrls: ['./package-link.component.scss']
})
export class PackageLinkComponent implements OnInit {
  public state: string = null;
  public packageInfo: any;
  public packageUtilisation: any;
  public isBookAppointment: boolean = false;
  public prefillData: any;
  packageDefinition: any;
  serviceDefinition: any;
  serviceInfo: any;
  enableOnspotConsult: boolean;
  public enableJoinAgain: boolean = false;
  public joinUrl: string;
  public isConsultationComplete: boolean = false;
  isSelected: any;
  switchLanguage: boolean;
  languageList: any;
  isNotSelected: any;
  timeFrom: string;
  timeTo: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private user: UserService,
    private cookie: CookieService,
    private packageService: PackageService,
    private router:Router,
    private onspotService: OnspotConsultationService
  ) { }

  ngOnInit(): void {
    this.initPackageValidation();
  }

  private initPackageValidation() {
    this.user.clearStorage();
    const params = this.activatedRoute.snapshot.params;
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.user.getLanguages().subscribe(data => {
      this.languageList = data;
    });

    this.isSelected = this.user.currentLanguage;
    this.checkNotSelected()

    const orderSetId = params['key'];
    const password = queryParams['pass'];
    const hash = queryParams['hash'];

    if (orderSetId && password && hash) {
      this.state = 'LOADING';
      this.validatePackageLink(orderSetId, password, hash);
    } else {
      this.state = 'INVALID';
    }
  }

  private validatePackageLink(orderSetId: string, password: string, hash: string) {
    this.packageService.validatePackageLink(orderSetId, password, hash).subscribe(data => {
      console.log(data);
      const packageInfo = data['packageInfo'];
      const repoInfo = data['repoInfo'];
      const token = data['token'];
      const userInfo = data['personInfo'];
      this.packageUtilisation = data['packageUtilisation'];
      this.handlePackageDetails(packageInfo, repoInfo, token, userInfo);
      this.state = null;
      if (!packageInfo) {
        this.state = 'INVALID';
      }
    }, err => {
      this.state = 'INVALID';
    });
  }

  private handlePackageDetails(packageInfo, repoInfo, token, userInfo) {
    this.setStorage(USER_TOKEN, token['token']);
    this.setStorage(REPO_TOKEN, repoInfo['token']);
    this.user.setRepoUrl(repoInfo['url']);
    let time = this.user.getMoment().add(environment.TOKEN_EXPIRY_HOURS, 'hours').valueOf();
    this.setStorage(EXPIRY_TIME, time);
    this.user.setUserInfoForPackageLink(userInfo, token,repoInfo);
    this.packageInfo = packageInfo;
    this.packageDefinition = this.user.getPackageFromUpdateCheck(packageInfo.orderCatalogCode);
    this.serviceDefinition = this.packageDefinition['packageDtls']?.['servicesApplicable']?.find(s => s['directiveCode'] == 'CN' && s['clinicConsultTypecode'] == 'ONSPOT' );
    if(this.serviceDefinition) {
      this.serviceInfo = this.packageUtilisation['packageServDtls'].find(s => s['serviceCode'] == this.serviceDefinition['conceptCode']);
      if (this.serviceInfo?.apptRef)
        this.callGetAppointmentByRef(this.serviceInfo.apptRef, this.packageInfo.facilityId);
      if(this.serviceInfo && !this.serviceInfo?.apptRef) {
      this.enableOnspotConsult = true;
      }
    }
    const data = this.user.getUpdateInfo('directives');
    if(data && data['userDefined']) {
      let directive = data['userDefined'].find(d => d['directiveCode'] == (this.serviceInfo['directiveCode'] || this.serviceInfo['serviceInd']));
      if(directive) {
        let service = directive['concepts'].find(c => c['code'] == this.serviceInfo['serviceCode']);
        if(service) {
          this.packageDefinition['careElementType'] = service['careElementType'];
        }
      }
    }
    // get the time from and to time from the package definition 
    let hlthPckgDtls = this.packageDefinition;
    if(this.packageDefinition) {
      let facilityHlthPckgDtls = this.packageDefinition?.facilities.find(c => c.facilityId == this.packageInfo.facilityId);
      this.timeFrom = facilityHlthPckgDtls?.controls?.timeFrom;
      this.timeTo = facilityHlthPckgDtls?.controls?.timeTo;
    }

  }

  private callGetAppointmentByRef(apptRef: string, facilityId: string) {
    const payload = {
      facilityId: facilityId,
      refNo: apptRef
    };
    this.onspotService.getAppointmentsByRefNo(payload).subscribe((res) => {
      let appt = res['data'];
      this.isConsultationComplete = appt?.visitStatusDesc === 'COMP';
      
      if (this.isConsultationComplete) {
        this.enableJoinAgain = false;
      } else if (appt?.joinUrl && appt['appointmentdatetime'] && moment(appt['appointmentdatetime'], 'YYYY/MM/DD HH:mm:ss').isSame(moment().startOf('day'), 'day')) {
        this.joinUrl = appt.joinUrl;
        this.enableJoinAgain = true;
      } else {
        this.enableJoinAgain = false;
      }
    },
      () => {
        this.enableJoinAgain = false;
        this.isConsultationComplete = false;
      }
    );
  }

  public setStorage(key, value) {
    this.cookie.set(key, value);
  }

  openOnspotConsult() {
    this.prefillData = {
      type: 'VIDEO-CONSULT-NOW',
      deeplinkParams: {
        speciality: this.packageInfo.specialityId || 'HECH',
        patientId: this.packageInfo.patientId,
        fromPackageLink: true,
        packageInfo: this.packageInfo,
        serviceInfo: this.serviceInfo,
        packageDefinition: this.packageDefinition,
        serviceDefinition: this.serviceDefinition,
        packageUtilisation: this.packageUtilisation,
      }
    }
    this.isBookAppointment = true;
  }
  closeBookAppointment(event) {
    this.isBookAppointment = false;
    this.prefillData = null;
    this.initPackageValidation();
  }
  takeToHome() {
    this.router.navigate(['/']);
  }
  public closeModal(){
    // this.isBookAppointment = true;
  }
  public download(type) {
    if (type == 'android') {
      let link = environment['urlInfo']['android'];
      this.user.openLocation(link, "_blank");
    }
    if (type == 'apple') {
      let link = environment['urlInfo']['iOS'];
      this.user.openLocation(link, "_blank");
    }
  }
  public joinAgain() {
    this.user.openLocation(this.joinUrl + "&source=px&lan=" + this.user.currentLanguage, true);
  }

    
  onItemChange(item){
    this.user.setDirection(item);
    this.isSelected = item.localeCode;
    this.switchLanguage = false;
    this.checkNotSelected();
  }

  public checkNotSelected() {
    this.languageList.every(item=>{
      if(item['localeCode'] === this.isSelected)
        return true;
      else {
        this.isNotSelected = item;
        return false;
      }
    })
  }

  public switchLanguageAction(){
    setTimeout(_ => {
      this.switchLanguage = !this.switchLanguage;
    }, 100)
  }
  
  public downloadReport(reportId: string) {
    this.user.geReportById(this.packageInfo.patientId, reportId, this.packageInfo.facilityId).subscribe(
      (response) => {
        console.log('Download Report Response:', response);
        const reportToken = response['accessToken'];
        const report = response['report'];
        this.getReportDataAndDownload(report, reportToken);
      },
      (error) => {
        console.error('Error downloading report:', error);
      }
    );
  }
  
  private getReportDataAndDownload(selectedReport, token) {
    this.user.getDownloadContent(selectedReport.url, token, false).subscribe(data => {
      if (selectedReport['format'] && selectedReport['format'] == 'FORMFORMAT') {
        data = JSON.parse(data);
      }
      // Format data based on report format
      let reportData = data;
      // if (selectedReport['format'] == 'JSONFORMAT') {
      //   reportData = JSON.stringify(data);
      // }
      
      this.formDownloadData(selectedReport, reportData);
    }, error => {
      console.error('Error fetching report content:', error);
    });
  }
  
  private formDownloadData(selectedReport, downloadcontent) {
    console.log("downloadcontent", downloadcontent);
    
    const data = {
      content: downloadcontent,
      facilityName: this.packageInfo.facilityName || '',
      facilityId: selectedReport['facilityId'] || this.packageInfo.facilityId,
      reportId: selectedReport['reportId'],
      patientName: this.packageInfo.patientName || '',
      uhid: this.packageInfo.patientId,
      personId: this.user.getPersonId(),
      gender: this.packageInfo.gender == 'M' ? 'Male' : this.packageInfo.gender == 'F' ? 'Female' : '',
      repDateTime: this.user.getMoment(selectedReport['reportDateTime']).format("DD-MM-YYYY hh:mm a"),
      age: this.packageInfo.age || 0,
      reportedBy: selectedReport['authorizedBy'] || '',
      isShare: false,
      filename: "report.pdf",
      reportType: selectedReport['format'],
      recordType: selectedReport['reportType'],
      encounterId: selectedReport['encounterId'],
      specialtyCode: selectedReport['specialtyCode'],
      entityId: selectedReport['entity'],
      doctorName: selectedReport['practitionerName'] || '',
      reportName: selectedReport['format'] == 'JSONFORMAT' ? selectedReport['eventGroupDesc'] : selectedReport['eventDesc'],
      reportData: selectedReport
    };
    
    this.getPDF(data);
  }
  
  private getPDF(data) {
    this.user.convertToPDF(data).subscribe(response => {
      let link = response['downloadLink'];
      this.user.openLocation(link, '_blank');
      console.log('Report downloaded successfully');
    }, error => {
      console.error('Error converting to PDF:', error);
    });
  }
  
}
